import { render } from "./HeroiconsOutlineGlobeAlt.vue?vue&type=template&id=bf41d264"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineGlobeAlt.vue"]])

export default __exports__